import React from 'react';
import { modules } from '../data/content';
export function Modules() {
  return <section className="bg-ice px-3 py-4 sm:px-6" data-id="element-101" data-mp="1r63rh4h50cko">
      <div className="mx-auto max-w-2xl" data-id="element-102" data-mp="1r4sq1bb5zgwq">
        <h2 className="text-center text-[1.2rem] font-extrabold uppercase text-navy sm:text-[1.8rem]" data-id="element-103" data-mp="1vx2e0lspy6wd">
          What's included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-104" data-mp="20uu214q8t8va">
          {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-navy/10 bg-white shadow-sm" data-id="element-105" data-mp="146o22v49n4nc">
              <div className="flex items-center gap-1.5 border-l-4 border-burgundy bg-navy px-2.5 py-1.5" data-id="element-106" data-mp="18899w21y0sqo">
                <span className="text-[0.8rem] leading-none" aria-hidden="true" data-id="element-107" data-mp="1d4zpypdqzoc3">
                  ✅
                </span>
                <h3 className="text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-white sm:text-[0.88rem]" data-id="element-108" data-mp="1i3krqt8neg2n">
                  Module {mod.number} — {mod.title}
                </h3>
              </div>
              <div className="px-2.5 py-2" data-id="element-109" data-mp="1v30ftcwoc7x">
                <p className="text-[0.78rem] leading-[1.35] sm:text-[0.92rem]" data-id="element-110" data-mp="1trvhq7q4yf8">{mod.body}</p>
                <p className="mt-1 font-heading text-[0.68rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.8rem]" data-id="element-111" data-mp="3tzwyvcfp4x6u">
                  {mod.steps}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}